export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_ALERT_STATUS = "SET_ALERT_STATUS";